import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import InstallButton from 'redesign/TopMenu/ShortcutButton';
import { DeferredPromptProvider } from 'context/DeferredPromptContext';
import App from './App';

import './index.css';
import './i18n';
import store from './redux/configureStore';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const queryClient = new QueryClient();

const Root: React.FC = () => {
	const [deferredPrompt, setDeferredPrompt] = useState(null);

	// Listen for the beforeinstallprompt event
	useEffect(() => {
		const promptEvent = (event: any) => {
			event.preventDefault(); // Prevent the default prompt
			setDeferredPrompt(event); // Save the event for later
		};

		window.addEventListener('beforeinstallprompt', promptEvent);

		return () => {
			window.removeEventListener('beforeinstallprompt', promptEvent);
		};
	}, []);

	return (
		<div>
			<DeferredPromptProvider>
				<QueryClientProvider client={queryClient}>
					<Provider store={store}>
						<div className="font-display max-h-screen">
							{/* Pass deferredPrompt as prop to InstallButton */}

							<App deferredPrompt={deferredPrompt} />
						</div>
					</Provider>
					<ReactQueryDevtools initialIsOpen />
				</QueryClientProvider>
			</DeferredPromptProvider>
		</div>
	);
};

ReactDOM.render(<Root />, document.getElementById('root'));

serviceWorkerRegistration.register();
